var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-button',{staticClass:"anBtn",attrs:{"color":_vm.color,"disabled":_vm.disabled,"loading":_vm.loading,"plain":_vm.plain,"round":_vm.round,"size":_vm.size,"square":_vm.square,"type":_vm.type,"hairline":"","native-type":"button"},on:{"click":_vm.sendcode}},[_vm._v(" "+_vm._s(_vm.disabled ? `${_vm.time}S` : '发送验证码')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }